import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Router, LocationProvider } from '@reach/router';
import history from '@agilytics/utils/history';
import { ThemeProvider } from 'styled-components';
import * as Sentry from '@sentry/browser';
import 'whatwg-fetch';

import { Compliance } from '@agilytics/containers';
import { App } from '@agilytics/entry';
import { AgilyticsProvider } from '@agilytics/global-state';
import { AnalyticsProvider } from '@agilytics/context/Analytics';
import { GlobalReset, theme } from '@agilytics/theme';

const { NODE_ENV } = process.env;

const Container = styled.section`
  position: relative;
  min-height: 100vh;
  padding-bottom: 5vh;
`;

if (NODE_ENV === 'production' && window.location.origin.includes('agilytics.leanloop.co.uk')) {
  Sentry.init({ dsn: 'https://448dc65608224f678a003657ad86cda5@o398976.ingest.sentry.io/5255438' });
}

ReactDOM.render(
  <React.StrictMode>
    <Container>
      <LocationProvider history={history}>
        <AgilyticsProvider>
          <AnalyticsProvider>
            <Compliance />
            <ThemeProvider theme={theme}>
              <GlobalReset />
              <Router>
                <App default />
              </Router>
            </ThemeProvider>
          </AnalyticsProvider>
        </AgilyticsProvider>
      </LocationProvider>
    </Container>
  </React.StrictMode>,
  document.getElementById('root')
);
